(function() {
  const firstMediaId = document.querySelector('media-gallery')?.dataset.firstMediaId;
  if (!firstMediaId) return;

  // 构建 media-id → 变体 radio 的映射表
  const mediaToVariant = {};
  document.querySelectorAll('input[type="radio"][name]').forEach(input => {
    const json = document.querySelector(`script[data-resource="${input.id}"]`);
    if (json) {
      try {
        const data = JSON.parse(json.textContent);
        if (data.featured_media) {
          mediaToVariant[String(data.featured_media.id)] = { name: input.name, value: input.value };
        }
      } catch(e) {}
    }
  });

  function selectVariantByMediaId(mediaId) {
    const variant = mediaToVariant[String(mediaId)];
    if (!variant) return;
    const input = document.querySelector(`input[type="radio"][name="${variant.name}"][value="${variant.value}"]`);
    if (input && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // 点击缩略图同步变体按钮
  document.querySelectorAll('.product-media-thumbnail').forEach(el => {
    el.addEventListener('click', function() {
      const mediaId = this.getAttribute('data-media-id');
      if (mediaId) selectVariantByMediaId(mediaId);
    });
  });

})();
